import { render, staticRenderFns } from "./WorldClock.vue?vue&type=template&id=cfaf8858&scoped=true&"
import script from "./WorldClock.vue?vue&type=script&lang=js&"
export * from "./WorldClock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfaf8858",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cfaf8858')) {
      api.createRecord('cfaf8858', component.options)
    } else {
      api.reload('cfaf8858', component.options)
    }
    module.hot.accept("./WorldClock.vue?vue&type=template&id=cfaf8858&scoped=true&", function () {
      api.rerender('cfaf8858', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/common/dashboard/panels/WorldClock.vue"
export default component.exports